module.exports = __webpack_public_path__ + "static/media/fluxwheel.f2bcb48f.jpg";